import { Spin as OriginalSpin } from "antd";

export default function Spin() {
  return (
    <div style={{ height: "100%", width: "100%", position: "relative" }}>
      <OriginalSpin
        size="large"
        style={{ position: "absolute", top: "50%", left: "50%" }}
      />
    </div>
  );
}
